import { SendaBasePriceResponse } from "./price-data-types";

export const getPaymentTableColumns = () => {
  const paymentTableColumns = [
    {
      text: "Forma de pago",
      filter: false,
      ascendent: true,
      key: "align-right-cell",
    },
    {
      text: "1er Recibo",
      filter: false,
      ascendent: true,
      key: "align-right-cell",
    },
    {
      text: "Sucesivos",
      filter: false,
      ascendent: false,
      key: "align-right-cell",
    },
  ];

  return paymentTableColumns;
};

export const getDefaultPriceResponse = (): SendaBasePriceResponse => {
  return {
    body: {
      RESPUESTA: {
        ASEGURADOS: [],
        DATOS_COTIZACION: {
          COLECTIVO: "",
          COMBINACION_COMERCIAL_POLIZA: "",
          COTIZACION: "",
          ESTADO: "",
          FECHA_EFECTO: "",
          LINEA_NEGOCIO: "",
          MEDIADOR: "",
        },
        FACTOR_COMERCIAL: {
          DESCUENTO_PORCENTAJE: "",
          TIPO_DESCUENTO: "",
        },
        IMPORTESFORPAGO: [],
        IMPORTES_ASEGURADO_GARANTIA: [],
        IMPORTES_COTIZACION_GARANTIA: [],
        RECIBOS: [],
        COBERTURAS: [],
        CAMPANYAS: [],
        DESCUENTO_ASEGURADO_PYMES: [],
      },
    },
  };
};
